import axios from 'axios';
import env from '../config/env';

const BASE_URL = env.apiUrl;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.info('[KOT] API base URL:', BASE_URL);
}

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: false,
  params: {},
  withCredentials: true, // ✅ important
});

instance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('jhms_token');
    config.headers['X-GHMS-Client'] = 'kot';

    if (token) {
      config.headers.common['Authorization'] = 'Bearer ' + token;
      config.headers.common['Accept'] = 'application/json';
    } else {
      config.headers.common['Content-Type'] =
        'application/x-www-form-urlencoded';
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('jhms_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default {
  get(action, params = {}) {
    return instance.get(action, params);
  },
  post(action, data) {
    return instance.post(action, data);
  },
  put(action, data) {
    return instance.put(action, data);
  },
  patch(action, data) {
    return instance.patch(action, data);
  },
  delete(action, data) {
    return instance.delete(action, data);
  },
};
